module.exports = __webpack_public_path__ + "static/media/spa-1.f99d9549.jpg";